module.exports = __webpack_public_path__ + "img/fr_inst.e2dc8f42.png";